import React from "react";

import { MDSSessionStandardView } from "@/mds/components/sessions/session-content/views/session-standard-view";
import { MDSSessionNotificationView } from "@/mds/components/sessions/session-content/views/session-notification-view";
import { MDSSessionSpinnerView } from "@/mds/components/sessions/session-content/views/session-spinner-view";
import { SessionViewMode } from "@/mds/components/sessions/session.constants";

type Props = {
  mode: SessionViewMode;
};

export const MDSSessionContentRenderer: React.FC<Props> = ({ mode }) => {
  switch (mode) {
    case SessionViewMode.Standard:
      return <MDSSessionStandardView />;
    case SessionViewMode.Notification:
      return <MDSSessionNotificationView />;
    case SessionViewMode.CollapsedSpinner:
      return <MDSSessionSpinnerView />;
    default:
      return null;
  }
};
